
import { fns, libTypes } from "@holta/lib";
import { useStore } from "../../config/store";
import { getEditOrder } from "./getEditOrder";
import {create} from 'mutative';

export const setDoorSupplier = (doorSupplier: libTypes.Order['doorSupplier']) => {

    const editOrder = getEditOrder();

    useStore.setState({
        editOrder : create(editOrder, draft => {
            draft.newValues.order.doorSupplier = fns.order.set.doorSupplier(doorSupplier);
        })
    });
};